export default {
  MASTER_CONDITION_MGMT_REQUEST: 'APP/MASTER_CONDITION/MASTER_CONDITION_MGMT_REQUEST',
  MASTER_CONDITION_MGMT_SUCCESS: 'APP/MASTER_CONDITION/MASTER_CONDITION_MGMT_SUCCESS',
  MASTER_CONDITION_MGMT_ERROR: 'APP/MASTER_CONDITION/MASTER_CONDITION_MGMT_ERROR',
};
